import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Environment } from 'src/environments/environment';

import { UrlHelpers } from './urlHelpers';
import { CropFieldImpact, EnvironmentalImpactReport } from '../models';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentalImpactService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.APIM_BASE_URL + '/environmental-metric-service/environmental-impact';

  getEnvironmentalImpactReport(
    cropFieldIds: number[],
  ): Observable<EnvironmentalImpactReport> {
    return this.http.get<CropFieldImpact[]>(
      `${this.baseUrl}?${UrlHelpers.getParamString('cropFieldIds', cropFieldIds)}`,
    ).pipe(
      map((cropFields) => ({ cropFields }) satisfies EnvironmentalImpactReport),
    )
  }
}
